//export const BACKEND_URL = `http://localhost:5000`;
export const BACKEND_URL = `https://learningaids.vercel.app`
export const FILE_HOST = 'https://lms.medicaltradesschool.com';